module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header_first_area",
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "menu_area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "user_some"
  }, [_c('div', {
    staticClass: "user_some_box"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    on: {
      "click": _vm.logInOut
    }
  }, [_vm._v(_vm._s(!_vm.isLoggedIn ? 'Belépés / regisztráció' : 'Kijelentkezés'))]), _vm._v(" "), (_vm.isLoggedIn) ? _c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v(_vm._s('(' + _vm.$store.getters.getCurrentUser + ')'))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "mainmenu"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "for_mobile"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, _vm._l((_vm.menus), function(m) {
    return _c('li', [(m.link) ? [(m.link.external) ? _c('a', {
      attrs: {
        "href": m.link.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(m.name))]) : _vm._e(), _vm._v(" "), (!m.link.external) ? _c('router-link', {
      attrs: {
        "to": m.link.url,
        "tag": "a"
      }
    }, [_vm._v(_vm._s(m.name))]) : _vm._e()] : _c('a', [_vm._v(_vm._s(m.name))])], 2)
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "estric"
  }, [_c('div', {
    staticClass: "estric_box"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/dashboard/profile"
    }
  }, [_c('span', [_vm._v("Profil")]), _c('i', {
    staticClass: "fa fa-user-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/dashboard/basket"
    }
  }, [_c('span', [_vm._v("Kosaram (" + _vm._s(_vm.basketSize == 0 ? 'üres' : _vm.basketSize + ' db') + ")")]), _c('i', {
    staticClass: "fa fa-shopping-basket",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#for_mobile",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0351f08","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/Header.vue
// module id = 287
// module chunks = 2